import classNames from 'classnames';
import { IconChevronDown } from 'featherico';
import * as React from 'react';
import styles from './style.m.less';

export default function SelectSimple({
    isSmall,
    className,
    hasError,
    children,
    options,
    placeholder,
    value,
    ...props
}: React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> & {
    isSmall?: boolean;
    hasError?: boolean;
    options?: { value: string; label: string }[];
    placeholder?: string;
}) {
    return (
        <div
            className={classNames(styles.container, className, {
                [styles.isSmall]: isSmall,
            })}
        >
            <select
                className={classNames(styles.select, {
                    [styles.hasError]: hasError,
                })}
                value={!value && placeholder !== undefined ? 'placeholder' : value}
                {...props}
            >
                {options ? (
                    <>
                        {placeholder !== undefined && (
                            <option disabled value="placeholder">
                                {placeholder}
                            </option>
                        )}
                        {options.map(({ label, value: optionValue }) => (
                            <option key={optionValue} value={optionValue}>
                                {label}
                            </option>
                        ))}
                    </>
                ) : (
                    children
                )}
            </select>
            <IconChevronDown className={styles.icon} />
        </div>
    );
}
